import SessionStorage from "sessionstorage";
import axios from "axios";
import {APIHOST} from "@/settings";

class BankService {
    get(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/BankInfo/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }
}

export default new BankService()